import React from 'react'
import { Link } from 'react-router-dom'
import Icon from '../misc/Icons'
import QuestionCountBadge from '../uiKit/QuestionCountBadge'
import { formatDate } from '../../utils/formatDate'
import { getRepoforId } from '../../utils/getRepoforId'

function LocalBadge({ item }) {
  if (!item.__localOrigin) return null
  if (item.__localEngine === 'minisearch') {
    return <Icon name='local-source-bm25' className='searchResults-localBadge searchResults-localBadge--bm25' />
  }
  return <Icon name='fuse-source' className='searchResults-localBadge' />
}

class SearchResultsCard extends React.Component {
  render() {
    const {
      title, item, question, set,
    } = this.props
    let linkPath = ''
    if (set) {
      const itemId = item.id || item._id
      linkPath = `/set/${itemId}`
    } else if (question) {
      const itemId = item.id || item._id
      linkPath = `/question/${itemId}`
    }

    let inSharedRepo = false
    let inPublicConsumerRepo = false
    let inPublicAuthorRepo = false
    if (item.repo) {
      const parentRepo = getRepoforId(item.repo)
      if (parentRepo) {
        inSharedRepo = parentRepo.shared
        inPublicConsumerRepo = parentRepo.role === 'consumer'
        inPublicAuthorRepo = parentRepo.role === 'author'
      }
    }

    const modifier = set ? 'set' : 'question'
    const questionCount = set && Array.isArray(item.questions) ? item.questions.length : undefined

    return (
      <Link to={linkPath}>
        <div className={`searchResultsRow searchResultsRow--${modifier}`}>
          <div className='searchResultsRow-icon'>
            {set ? (
              <QuestionCountBadge
                color='blueLight'
                size='medium'
                questionCount={questionCount}
              />
            ) : (
              <QuestionCountBadge color='blueLight' size='medium' questionCount='–' />
            )}
          </div>
          <div className='searchResultsRow-body'>
            <div className='searchResultsRow-title'>
              <span className='searchResultsRow-title-text'>{title}</span>
              {inSharedRepo && <Icon name='shared' />}
              {inPublicConsumerRepo && <Icon name='globe-shared' />}
              {!set && !question && inPublicAuthorRepo && <Icon name='globe-shared-author' />}
              <LocalBadge item={item} />
            </div>
            <div className='searchResultsRow-meta'>
              {'Edited '}
              {formatDate(item.clientModified)}
            </div>
          </div>
        </div>
      </Link>
    )
  }
}

export default SearchResultsCard
